import * as types from './types'

export default {
  [types.ADD_GROUP] (state, group) {
    state.groups.push(group)
  },
  [types.DELETE_GROUP] (state, group) {
    state.groups.splice(state.groups.indexOf(group), 1)
  },
  [types.SET_GROUP] (state, group) {
    state.group = group
  },
  [types.SET_GROUPS] (state, groups) {
    state.groups = groups || []
  },
  [types.RESET_GROUP] (state) {
    state.group = {
      id: 0,
      name: null,
      surveyTypeID: null,
      locationID: null,
      k12Education: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/group/mutations.js